import { configureStore} from '@reduxjs/toolkit';
import authenticationReducer from '../auth/AuthenticationSlice';
import createSagaMiddleware from '@redux-saga/core';
import rootSaga from '../core/RootSaga';
import StorageSlice from '../storage/StorageSlice';
import generalErrorSlice from '../helper/general-error/GeneralErrorSlice';
import notetakerSlice from '../notetaker/NotetakerSlice'
import todosSlice from '../todos/TodosSlice';
import dbsSlice, { triggerDBUploader, triggerDbVerification } from '../dbs/dbsSlice';
import confirmationSlice from '../helper/confirmation-modal/confirmationSlice';
import scriptSlice from '../scripts/ScriptManagerSlice';
import rpcSlice from '../rpc/RPCSlice';
import generalDetailSlice from '../helper/general-details/GeneralDetailSlice';
import timerSlice from '../timer/TimerSlice';
import notificacoesSlice from '../notificacoes/NotificacoesSlice';
import loadingSlice from './loading/LoadingSlice';
import livrudoSlice from '../livrudo/LivrudoSlice';
import workSlice from '../work/WorkSlice';

const sagaMiddleWare = createSagaMiddleware();

export const store = configureStore({
  middleware : (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleWare),
  reducer: {
    auth: authenticationReducer,
    storage: StorageSlice,
    generalError : generalErrorSlice,
    generalDetail : generalDetailSlice,
    notetaker : notetakerSlice,
    todos : todosSlice,
    dbs : dbsSlice,
    confirmation : confirmationSlice,
    scripts : scriptSlice,
    rpc: rpcSlice,
    timer: timerSlice,
    notificacoes : notificacoesSlice,
    loading : loadingSlice,
    livrudo : livrudoSlice,
    work : workSlice,
  },
});

sagaMiddleWare.run(rootSaga);

store.dispatch(triggerDBUploader())
store.dispatch(triggerDbVerification())
